module.exports = __webpack_public_path__ + "static/img/bg_9.99ea7b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_9.png
// module id = 782
// module chunks = 1